/**
 * Foundation/Core — Download utility
 *
 * Avvia un download in modo compatibile con i browser desktop.
 * L'URL temporaneo resta valido abbastanza a lungo da consentire al browser
 * di acquisire il file anche quando il payload (es. PDF) richiede qualche istante.
 *
 * Utility 100% agnostica rispetto al dominio: puo' essere utilizzata da qualsiasi
 * Product Pack della Gruppo Impresa Suite.
 */
export function downloadBlob(blobLike, filename, contentType = "application/octet-stream") {
  const blob = blobLike instanceof Blob
    ? blobLike
    : new Blob([blobLike], { type: contentType });
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();

  window.setTimeout(() => {
    link.remove();
    window.URL.revokeObjectURL(objectUrl);
  }, 1500);
}
